import { Stack, Typography, useTheme } from "@mui/material";
import { useMaterials } from "contexts/search/SearchContextProvider";
import { useMemo } from "react";
import { useTenantTranslation } from "src/hooks/formatters";
import { Plan } from "store/api/generatedApi";
import { PlanCard } from "./planCard/card";
import { PlanCardData, planCards } from "./planCard/data";
import { PlanCardSkeleton } from "./planCard/skeleton";

export const SuccessfulSearch = ({
  plans,
  primary,
  incompleteResults,
  onClickPlan,
}: {
  plans: Plan[];
  primary: boolean;
  incompleteResults?: boolean;
  onClickPlan: (planCard: PlanCardData) => void;
}) => {
  const { t } = useTenantTranslation();
  const theme = useTheme();
  const searchMaterials = useMaterials();

  const cards = useMemo(() => {
    const materials =
      searchMaterials.status === "success" ? searchMaterials.data.byIndex : [];
    return planCards(plans, materials);
  }, [plans, searchMaterials]);

  const planResults = useMemo(
    () =>
      cards.map(
        ({
          planId,
          planIndex,
          planName,
          basePlanId,
          planType,
          searchId,
          metrics,
          optimisationSlackVariableUsage,
          optimisationStatus,
          deployments,
          createdByName,
          createdAt,
          comment,
        }) => (
          <PlanCard
            key={planIndex}
            planId={planId}
            planIndex={planIndex}
            planName={planName}
            basePlanId={basePlanId}
            planType={planType}
            searchId={searchId}
            metrics={metrics}
            optimisationStatus={optimisationStatus}
            optimisationSlackVariableUsage={optimisationSlackVariableUsage}
            deployments={deployments}
            onClick={onClickPlan}
            createdByName={createdByName}
            createdAt={createdAt}
            comment={comment}
          />
        )
      ),
    [cards, onClickPlan]
  );

  return (
    <>
      {!primary && (
        <Typography sx={{ mb: 2, color: theme.palette.text.secondary }}>
          {t("similarResults")}
        </Typography>
      )}
      <Stack spacing={1}>
        {planResults}
        {incompleteResults ? <PlanCardSkeleton /> : null}
      </Stack>
    </>
  );
};
